/**
 * <saintrac-filter-bar>
 * Wraps the filter/sort form. On any change, serializes form data
 * and navigates via full page reload (no AJAX).
 */
if (!customElements.get('saintrac-filter-bar')) {
  class SaintracFilterBar extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleChange() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (value !== '' && value !== undefined) {
          params.append(key, value);
        }
      }

      // Preserve the base path, replace search params
      const url = new URL(window.location.href);
      url.search = params.toString();
      window.location.href = url.toString();
    }

    handleClick(event) {
      // Handle "remove filter" pill buttons
      const removeBtn = event.target.closest('[data-remove-url]');
      if (removeBtn) {
        event.preventDefault();
        window.location.href = removeBtn.dataset.removeUrl;
      }

      // Handle "clear all" link
      const clearBtn = event.target.closest('[data-clear-url]');
      if (clearBtn) {
        event.preventDefault();
        window.location.href = clearBtn.dataset.clearUrl;
      }
    }
  }

  customElements.define('saintrac-filter-bar', SaintracFilterBar);
}
